export default __webpack_public_path__ + "static/media/onboarding_imgs_02.17a5917c.png";